module.exports = __webpack_public_path__ + "img/lighting.ea1553c9.svg";